import script from "./ReferenceSummary.vue?vue&type=script&setup=true&lang=js"
export * from "./ReferenceSummary.vue?vue&type=script&setup=true&lang=js"

import "./ReferenceSummary.vue?vue&type=style&index=0&id=1710adce&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-1710adce"]])

export default __exports__